import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface BreadcrumbProps {
  children: React.ReactNode;
  className?: string;
}

export function Breadcrumb({ children, className = '' }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className={className}>
      {children}
    </nav>
  );
}

export function BreadcrumbList({ children }: { children: React.ReactNode }) {
  return (
    <ol className="flex items-center gap-1.5 text-sm text-gray-500">
      {children}
    </ol>
  );
}

export function BreadcrumbItem({ children }: { children: React.ReactNode }) {
  return (
    <li className="inline-flex items-center gap-1.5">
      {children}
    </li>
  );
}

export function BreadcrumbLink({ href, children }: { href: string; children: React.ReactNode }) {
  return (
    <Link to={href} className="hover:text-gray-700 transition-colors">
      {children}
    </Link>
  );
}

export function BreadcrumbSeparator() {
  return (
    <li role="presentation" aria-hidden="true" className="inline-flex items-center">
      <ChevronRight className="h-3.5 w-3.5 text-gray-400" />
    </li>
  );
}

export function BreadcrumbPage({ children }: { children: React.ReactNode }) {
  return (
    <span className="font-medium text-gray-700" aria-current="page">
      {children}
    </span>
  );
}
